import type { TFunction } from 'i18next';
import type { NetworkCostPolicyDto } from '@shared/api/contracts/reconciliation';

export type PolicyAppliesToKind = 'global' | 'merchant';

export const policyAppliesToKind = (policy: Pick<NetworkCostPolicyDto, 'merchantId'>): PolicyAppliesToKind =>
  policy.merchantId != null ? 'merchant' : 'global';

export const policyAppliesToLabel = (t: TFunction<'cabinet'>, policy: Pick<NetworkCostPolicyDto, 'merchantId'>): string => {
  const kind = policyAppliesToKind(policy);
  if (kind === 'merchant') {
    return t('reconciliation.policies.appliesTo.merchant', { id: policy.merchantId });
  }
  return t('reconciliation.policies.appliesTo.global');
};

export const policyOperationLabel = (t: TFunction<'cabinet'>, operationType: string): string =>
  t(`reconciliation.policies.operation.${operationType}`, { defaultValue: operationType });

export const policyPayerLabel = (t: TFunction<'cabinet'>, payer: string): string =>
  t(`networkCost.payer.${payer}`, { defaultValue: payer });

/** API отдаёт Decimal-строку; в UI показываем компактный процент без лишних нулей. */
export const formatPolicyBufferPercent = (bufferPercent: string): string => {
  const value = Number.parseFloat(bufferPercent);
  if (!Number.isFinite(value)) return bufferPercent;
  const compact = Number(value.toFixed(2));
  return `${compact}%`;
};
